/**
 * Gli eventi di Pixel (congressi, convegni): il programma, le regole di
 * scelta e il percorso di ogni partecipante.
 *
 * Sta fuori da src/ perche' lo usano sia le schermate di Pixel (tabellone
 * delle assegnazioni) sia le funzioni (evento-pubblico, che non si fida di
 * quello che arriva dal browser, e il motore email che compone il percorso
 * nelle email). Una sola copia delle regole.
 *
 * Il programma arriva da un file JSON esportato dall'app dell'evento
 * (per HS&UT: `npm run esporta-programma` in SLAB - SEMINARIO/app).
 */

export interface GiornoEvento {
  /** Codice breve usato nei percorsi, es. 'g1'. */
  codice: string;
  /** Data in ora italiana, AAAA-MM-GG. */
  data: string;
  /** Come si legge, es. 'Giovedi' 5 novembre'. */
  nome: string;
}

export interface TurnoEvento {
  /** Numero del turno, da 1. */
  n: number;
  inizio: string;
  fine: string;
}

export interface AulaEvento {
  /** Codice breve, es. 'a', '12', 'parchi'. */
  codice: string;
  nome: string;
  /** Posti a sedere; null = nessun limite (o non ancora deciso). */
  posti: number | null;
}

export interface SessioneEvento {
  /** Codice stabile, es. 'g1-t1-a': e' quello che finisce nei percorsi. */
  codice: string;
  giorno: string;
  /** Il turno della sessione; null per la mattina e per chi dura tutto il pomeriggio. */
  turno: number | null;
  /** I turni che la sessione occupa: [2] per un turno, [1,2,3,4] per tutto il pomeriggio, [] per la mattina. */
  turni: number[];
  inizio: string;
  fine: string;
  aula: string;
  titolo: string;
  relatori: string;
  /** Si puo' scegliere nel percorso (no per plenarie, BeSafeX, Aula Mare...). */
  sceglibile: boolean;
}

export interface ProgrammaEvento {
  versione: 1;
  giorni: GiornoEvento[];
  turni: TurnoEvento[];
  aule: AulaEvento[];
  sessioni: SessioneEvento[];
}

/** Come si sceglie: lo decide chi organizza, evento per evento. */
export interface RegoleScelta {
  /** Bisogna scegliere in tutti i turni di tutti i giorni prima di inviare. */
  tutti_i_turni: boolean;
  /** Una lezione ripetuta in piu' turni si segue una volta sola al giorno. */
  lezione_una_volta_al_giorno: boolean;
}

export const REGOLE_PREDEFINITE: RegoleScelta = {
  tutti_i_turni: true,
  lezione_una_volta_al_giorno: true,
};

/**
 * Il percorso di una persona: giorno -> turno -> codice della sessione.
 * Le chiavi dei turni sono stringhe ('1'..'4') perche' arrivano da JSON.
 * Una sessione lunga (Aula Parchi) compare in tutti i turni che occupa.
 */
export type Percorso = Record<string, Record<string, string>>;

export type StatoAssegnazione = 'nessuna' | 'bozza' | 'confermata';

/** Quello che serve del partecipante per proporre l'assegnazione. */
export interface PartecipantePerAssegnazione {
  id: string;
  richiesta: Percorso | null;
  /** Momento dell'invio della richiesta (ISO): decide l'ordine di arrivo. */
  richiesta_at: string | null;
  assegnazione: Percorso | null;
  assegnazione_stato: StatoAssegnazione;
}
